var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 36 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M21.446 12.173h-6.38a.5.5 0 0 1-.49-.41L12.406.693a.5.5 0 0 1 .11-.42.49.49 0 0 1 .39-.18h10.28a.48.48 0 0 1 .38.18.48.48 0 0 1 .11.4l-1.77 11.07a.5.5 0 0 1-.46.43zm-6-1h5.54l1.61-10.08h-9.09l1.94 10.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.046 15.853a.5.5 0 0 1-.5-.5v-3.68a.5.5 0 1 1 1 0v3.68a.51.51 0 0 1-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.156 22.163a3.67 3.67 0 0 1-3.38-2.23.52.52 0 0 1 .27-.66.51.51 0 0 1 .66.27 2.66 2.66 0 1 0 2.45-3.69.5.5 0 1 1 0-1 3.66 3.66 0 0 1 0 7.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M34.716 43.243H1.406a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5h33.31a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-.5.5zm-32.81-1h32.31v-16H1.906v16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.816 26.223a.41.41 0 0 1-.16 0l-15.38-5.23-16.19 5.2a.49.49 0 0 1-.62-.32.5.5 0 0 1 .32-.63l16.34-5.26a.47.47 0 0 1 .31 0l15.54 5.25a.51.51 0 0 1 .31.64.49.49 0 0 1-.47.35zM5.846 39.643a.51.51 0 0 1-.5-.5v-9.82a.5.5 0 1 1 1 0v9.82a.5.5 0 0 1-.5.5zM11.766 39.643a.5.5 0 0 1-.5-.5v-9.82a.5.5 0 1 1 1 0v9.82a.5.5 0 0 1-.5.5zM17.706 39.643a.51.51 0 0 1-.5-.5v-9.82a.5.5 0 1 1 1 0v9.82a.5.5 0 0 1-.5.5zM23.906 39.643a.5.5 0 0 1-.5-.5v-9.82a.5.5 0 1 1 1 0v9.82a.51.51 0 0 1-.5.5zM30.276 39.643a.5.5 0 0 1-.5-.5v-9.82a.5.5 0 1 1 1 0v9.82a.51.51 0 0 1-.5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.1ea5613a3da3e708b19fc943cf318314.svg";
export { ForwardRef as ReactComponent };